export default "__VITE_ASSET__DZv$xC9i__"